export default
    {
        // url: this.$store.state.http.biomedica.YYYY,
        listEquipos: "/biomedica/listEquipos",
        guardaEquipo: "/biomedica/guardaEquipo",

        listManuales: "/biomedica/listManuales",
        guardaManual: "/biomedica/guardaManual",

        listSolicitudes: "/biomedica/listSolicitudes",
        printOrdenSf: "/biomedica/printOrdenSf",

        listProgramados: "/biomedica/listProgramados",
        guardaProgramado: "/biomedica/guardaProgramado",
        guardaPedido: "/biomedica/guardaPedido",

        printEquipos: "/biomedica/printEquipos",
        imprimeCalendarioMtto: "/biomedica/imprimeCalendarioMtto",
        imprimeCalendarioTodos: "/biomedica/imprimeCalendarioTodos",

        guardaImagenReporte: "/biomedica/guardaImagenReporte",

        cuentaActividad: "/biomedica/cuentaActividad",
    }
